var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26699(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26699",
    "data-name": "Group 26699",
    transform: "translate(-1068 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(1068 788)",
    fill: "#fb7b18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23257",
    "data-name": "Path 23257",
    d: "M772.165,85.455a18.76,18.76,0,1,1-18.76-18.76,18.758,18.758,0,0,1,18.76,18.76m-33.29-4.682.687,1.267a4.689,4.689,0,0,0,2.786,2.184l4.178,1.209a2.913,2.913,0,0,1,2.191,2.821v2.924a1.952,1.952,0,0,0,1.172,1.832,2.3,2.3,0,0,1,1.172,1.964v2.858a1.714,1.714,0,0,0,2.19,1.649,3.547,3.547,0,0,0,2.4-2.47l.205-.821a4.711,4.711,0,0,1,2.22-2.939l.594-.337a3.5,3.5,0,0,0,1.774-3.056v-.6a3.522,3.522,0,0,0-1.034-2.491l-.279-.279a3.6,3.6,0,0,0-2.491-1.1h-3.225a4.591,4.591,0,0,1-2.264-.55l-2.528-1.45a1.438,1.438,0,0,1-.667-.814,1.49,1.49,0,0,1,.74-1.8l.44-.213a1.881,1.881,0,0,1,1.5-.11l1.765.564a1.4,1.4,0,0,0,1.518-2.228l-1-1.187a2.342,2.342,0,0,1,.022-3.027l1.151-1.346a2.346,2.346,0,0,0,.256-2.69l-.175-.3c-.315-.012-.506-.019-.763-.019a15.272,15.272,0,0,0-14.53,10.56m27.838-2.756-1.876.755a2.348,2.348,0,0,0-1.355,2.916L764.72,85.4a2.363,2.363,0,0,0,1.656,1.539l2.14.527a15.3,15.3,0,0,0-1.8-9.453",
    transform: "translate(350.354 738.305)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26699);
export default __webpack_public_path__ + "static/media/Group 26699.0f7edec89150cfa07a34063163cad047.svg";
export { ForwardRef as ReactComponent };